import {StatisticsPeriod} from "@ucirq/protocol/lib/protocol/returns";
import {returnsClient} from "./HttpClients";

export const getStatistics = (period: StatisticsPeriod) => {
    return returnsClient.getStatistics(period)
}